export const BASE_NOTIFICATION_HEIGHT = 78;
export const NOTIFICATIONS_CROP = 2;
